import React from 'react';
import classnames from 'classnames';
import { Col } from 'react-bootstrap';
import { Media } from '../Media';
import '../styles/index.scss';
var defaultProps = {
  children: null,
  mediaAlt: 'Default Alt',
  mediaSrc: null,
  mediaCaption: 'Default Caption',
  brand: 'law',
  mediaLeft: true,
  hasEmbeddedVideo: false
};
var MediaBlock = function MediaBlock(_ref) {
  var brand = _ref.brand,
    children = _ref.children,
    mediaSrc = _ref.mediaSrc,
    mediaAlt = _ref.mediaAlt,
    mediaCaption = _ref.mediaCaption,
    mediaLeft = _ref.mediaLeft,
    hasEmbeddedVideo = _ref.hasEmbeddedVideo;
  var xsMediaColStyling = {
    span: 12,
    order: 0
  };
  var lgMediaColStyling = {
    order: 0,
    span: 5,
    offset: mediaLeft ? 1 : 0
  };
  var mediaWrapperStyling = classnames({
    'p-0 align-self-center': true,
    'embed-responsive embed-responsive-16by9 content-block-media-wrapper': hasEmbeddedVideo
  });
  if (!children && !mediaSrc) return null;
  return /*#__PURE__*/React.createElement(Col, {
    "data-testid": "content-block-media",
    lg: lgMediaColStyling,
    xs: xsMediaColStyling,
    className: mediaWrapperStyling
  }, children || /*#__PURE__*/React.createElement(Media, {
    src: mediaSrc,
    alt: mediaAlt,
    caption: mediaCaption,
    brand: brand
  }));
};
MediaBlock.defaultProps = defaultProps;
export { MediaBlock };